function isLeadPackage(pkg: App.BedbankPackage, leadSell: App.BedbankSellPriceInfo): boolean {
  return pkg.sell?.basePrice === leadSell.basePrice && pkg.sell.los === leadSell.los
}

export default function getBedbankPricedPackage(
  offer: App.BedbankOffer | App.BedbankOfferSummary | App.BedbankOfferWithRate,
  rate?: App.BedbankRate,
): App.BedbankPackage | undefined {
  if (rate?.room) return rate.room
  if (offer.packages.length === 1) return offer.packages[0]

  const leadSell = offer.sell
  return leadSell ? offer.packages.find(pkg => isLeadPackage(pkg, leadSell)) : undefined
}
